const accordionCl = {
  wrapper: 'nested-accordion-js',
  tab: 'nested-accordion-tab-js',
  tabActiveIcon: 'nested-accordion-active-icon-js',
  content: 'nested-accordion-content-js',
};

const handleTabContent = function (clickedTab, accordionParent) {
  const clickedTabNumber = clickedTab.getAttribute('data-accordion-number');
  const clickedTabLevel = clickedTab.parentElement.getAttribute(
    'data-accordion-level',
  );
  const clickedTabSiblings = [...clickedTab.parentElement.children].filter(
    (child) => child.getAttribute('data-accordion-number') === clickedTabNumber,
  );

  const activeAccordions = [
    ...accordionParent.querySelectorAll('[data-accordion-active]'),
  ];

  // if no accordions are currently open
  if (activeAccordions.length < 1) {
    const filteredSiblings = clickedTabSiblings.filter(
      (child) => child != clickedTab,
    );

    filteredSiblings.forEach(
      (sibling) => (sibling.style.height = sibling.scrollHeight + 'px'),
    );

    clickedTab.classList.add(accordionCl.tabActiveIcon);

    clickedTab.setAttribute('aria-expanded', 'true');
    clickedTab.setAttribute('data-accordion-active', '');
    return;
  }

  // if the clicked tab is already active, so close it
  if (clickedTab.hasAttribute('data-accordion-active')) {
    const filteredSiblings = clickedTabSiblings.filter(
      (child) => child != clickedTab,
    );

    filteredSiblings.forEach((sibling) => (sibling.style.height = '0px'));

    if (clickedTabLevel === 'nested-level')
      clickedTab.parentElement.style.height = clickedTab.scrollHeight + 'px';

    clickedTab.classList.remove(accordionCl.tabActiveIcon);

    clickedTab.setAttribute('aria-expanded', 'false');
    clickedTab.removeAttribute('data-accordion-active');
    return;
  }

  // if the clicked tab is top-level, close all the other top level accordions
  if (clickedTabLevel === 'top-level') {
    [...clickedTab.parentElement.children].forEach((child) => {
      if (child.hasAttribute('data-accordion-active')) {
        child.classList.remove(accordionCl.tabActiveIcon);
        child.setAttribute('aria-expanded', 'false');
        child.removeAttribute('data-accordion-active');
      }
      if (child.getAttribute('data-accordion-level') === 'nested-level') {
        child.style.height = '0px';
        child.firstElementChild.removeAttribute('data-accordion-active');
        child.firstElementChild.classList.remove(accordionCl.tabActiveIcon);
      }
    });

    clickedTab.classList.add(accordionCl.tabActiveIcon);

    const filteredSiblings = clickedTabSiblings.filter(
      (child) => child != clickedTab,
    );

    filteredSiblings.forEach(
      (sibling) =>
        (sibling.style.height = sibling.firstElementChild.scrollHeight + 'px'),
    );

    clickedTab.setAttribute('aria-expanded', 'true');
    clickedTab.setAttribute('data-accordion-active', '');
    return;
  }

  // if the clicked tab is nested-level, close all the other sibling accordions
  if (clickedTabLevel === 'nested-level') {
    [
      ...accordionParent.querySelectorAll(
        '[data-accordion-level = nested-level]',
      ),
    ].forEach((acc) => {
      if (acc.getAttribute('data-accordion-number') === clickedTabNumber) {
        const firstChild = acc.firstElementChild;
        acc.style.height = acc.firstElementChild.scrollHeight + 'px';
        firstChild.setAttribute('aria-expanded', 'false');
        firstChild.removeAttribute('data-accordion-active');
        firstChild.classList.remove(accordionCl.tabActiveIcon);
      }
    });

    clickedTab.classList.add(accordionCl.tabActiveIcon);

    const filteredSiblings = clickedTabSiblings.filter(
      (child) => child != clickedTab,
    );
    filteredSiblings.forEach(
      (sibling) => (sibling.style.height = sibling.scrollHeight + 'px'),
    );

    const newContainerHeight = clickedTabSiblings.reduce(
      (acc, child) => child.scrollHeight + acc,
      0,
    );
    clickedTab.parentElement.style.height = newContainerHeight + 'px';

    clickedTab.setAttribute('aria-expanded', 'true');
    clickedTab.setAttribute('data-accordion-active', '');
    return;
  }
};

const handleAccordionOnResize = function (
  accordionParent,
  accordionsCollapsed,
) {
  if (accordionsCollapsed) return true;

  const allActiveAccordions = [
    ...accordionParent.querySelectorAll('[data-accordion-active]'),
  ].reverse();

  allActiveAccordions.forEach((acc) => {
    if (
      acc.parentElement.getAttribute('data-accordion-level') === 'top-level'
    ) {
      acc.parentElement
        .querySelectorAll(
          `div[data-accordion-number = "${acc.getAttribute(
            'data-accordion-number',
          )}"]`,
        )
        .forEach((nested) => (nested.style.height = 0));
      acc.removeAttribute('data-accordion-active');
      acc.classList.remove(accordionCl.tabActiveIcon);
    }
    if (
      acc.parentElement.getAttribute('data-accordion-level') === 'nested-level'
    ) {
      acc.removeAttribute('data-accordion-active');
      acc.nextElementSibling.style.height = '0';
      acc.parentElement.style.height = '' + acc.scrollHeight + 'px';
      acc.classList.remove(accordionCl.tabActiveIcon);
    }
  });

  return true;
};

export default function () {
  const accordionParent = document.querySelector('.' + accordionCl.wrapper);
  let accordionsCollapsed = true;
  if (!accordionParent) return;

  accordionParent.addEventListener('click', (e) => {
    const clickedTab = e.target.closest('.' + accordionCl.tab);
    if (!clickedTab) return;
    accordionsCollapsed = false;

    handleTabContent(clickedTab, accordionParent);
  });

  let windowWidth = window.innerWidth;
  window.addEventListener('resize', (e) => {
    if (windowWidth === window.innerWidth) return;
    accordionsCollapsed = handleAccordionOnResize(
      accordionParent,
      accordionsCollapsed,
    );
    if (accordionsCollapsed) windowWidth = window.innerWidth;
  });
}
